export const getLatLonFromPath = (pathname) => {
  const tokenizedPath = pathname.lastIndexOf('@');
  const splitLocation = pathname.substr(tokenizedPath + 1).split(',');
  return (splitLocation.length > 1) ? splitLocation.map(loc => Number(loc)) : [0, 0];
};



// WEBPACK FOOTER //
// ./src/utils/urls/getLatLonFromPath.js